import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=05bc7a77&scoped=true&"
import script from "./RegisterPage.vue?vue&type=script&lang=js&"
export * from "./RegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RegisterPage.vue?vue&type=style&index=1&id=05bc7a77&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bc7a77",
  null
  
)

export default component.exports